export default __webpack_public_path__ + "static/logo-2a61421359233c8bf1ddded035656412.svg";